import { render, staticRenderFns } from "./staff_create.vue?vue&type=template&id=0f37b924&"
import script from "./staff_create.vue?vue&type=script&lang=js&"
export * from "./staff_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports